import { Dispatch, SetStateAction } from 'react';

import { Box, Button, DialogActions, DialogContent, Typography } from '@mui/material';

import { LockingDisableButton } from '@/components/DisableableButton';
import SmallDialog from '@/components/SmallDialog';

const ConfirmDialog = ({
  open,
  setOpen,
  deleteCallback
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  deleteCallback: () => void;
}) => {
  return (
    <SmallDialog
      handleClose={() => {
        setOpen(false);
      }}
      open={open}
    >
      <>
        <DialogContent sx={{ paddingBottom: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              sx={{ mb: 3 }}
              variant='subtitle2'
            >
              Delete API token?
            </Typography>
            <Typography
              sx={{ mr: 3 }}
              variant='subtitle2'
            >
              Are you sure you want to delete this API token?
              <br />
              This action cannot be undone, and any applications using this token will lose access.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button
            sx={{ mr: 2, height: 48 }}
            variant='text'
            onClick={() => {
              setOpen(false);
            }}
          >
            Cancel
          </Button>
          <LockingDisableButton
            clickCallback={() => {
              deleteCallback();
            }}
            sx={{ height: 48 }}
            variant='contained'
          >
            Delete token
          </LockingDisableButton>
        </DialogActions>
      </>
    </SmallDialog>
  );
};
export default ConfirmDialog;
